/**
 * Die sieben Sportschulen mit Postfach und Adresse — wie im CRM
 * (crm.schools, Stand 29.09.2026). Das Mailtool schreibt Wilmersdorf als
 * „Charlottenburg", Spandau hat zwei Träger; `orgs` ist die Schreibweise in
 * den Empfängergruppen (studio_scope) und in den Rechten der Studioleitung.
 */
export interface Sportschule {
  name: string;
  email: string;
  adresse: string;
  orgs: string[];
}

export const SPORTSCHULEN: Sportschule[] = [
  { name: 'Lübars',      email: 'luebars@randori-pro.de',     adresse: 'Zabel-Krüger-Damm 123, 13469 Berlin', orgs: ['Lübars'] },
  { name: 'Mariendorf',  email: 'mariendorf@randori-pro.de',  adresse: 'Alt-Mariendorf 19-21, 12107 Berlin',  orgs: ['Mariendorf'] },
  { name: 'Spandau',     email: 'spandau@randori-pro.de',     adresse: 'Askanierring 155, 13585 Berlin',      orgs: ['Spandau', 'Spandau gGmbH'] },
  { name: 'Steglitz',    email: 'steglitz@randori-pro.de',    adresse: 'Steglitzer Damm 76, 12169 Berlin',    orgs: ['Steglitz'] },
  { name: 'Tegel',       email: 'tegel@randori-pro.de',       adresse: 'Ernststraße 2-4, 13509 Berlin',       orgs: ['Tegel'] },
  { name: 'Waltersdorf', email: 'waltersdorf@randori-pro.de', adresse: 'Zeppelinstraße 4b, 12529 Schönefeld', orgs: ['Waltersdorf'] },
  { name: 'Wilmersdorf', email: 'wilmersdorf@randori-pro.de', adresse: 'Berliner Straße 30, 10715 Berlin',    orgs: ['Charlottenburg'] },
];

export const BACKOFFICE = { name: 'Backoffice', email: 'backoffice@randori-pro.de', adresse: 'Innsbrucker Str. 4, 10825 Berlin' };

export function sportschule(name: string | null | undefined): Sportschule | null {
  return SPORTSCHULEN.find((s) => s.name === name) ?? null;
}

/** Sportschulen, für die eine Studioleitung zuständig ist (aus ihren Mailtool-Studios). */
export function sportschulenFuerStudios(studios: string[]): Sportschule[] {
  return SPORTSCHULEN.filter((s) => s.orgs.some((o) => studios.includes(o)));
}
